const FullPageLoader = () => {
  return (
    <div
      style={{
        width: '100%',
        height: '92.5vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'var(--brand-page-bg)',
      }}
    >
      <div className="spinner" />
    </div>
  );
};

export default FullPageLoader;
